// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"eW-z","sponsoredTooltipWrapper":"fW-z","sponsoredTooltip":"gW-z","newCard":"hW-z"};